enum ECompanyNewsTab {
  BLOG = 'blog',
  CASES = 'cases',
}

export {ECompanyNewsTab};
